import { combineReducers } from "redux";
import { combineEpics } from "redux-observable";
import auth, { authEpic } from "reducers/auth";
import header from "reducers/header";
import modals from "reducers/modals";
import globalModal from "reducers/globalModal";
import verification, { verificationEpic } from "reducers/verification";
import userInfo, { updateUserInfoEpic } from "./userInfo";
import guarantees from "reducers/guarantees";
import notification from "reducers/notificationReducer";

export const rootReducer = combineReducers({
  auth,
  header,
  modals,
  userInfo,
  verification,
  globalModal,
  guarantees,
  notification,
});
export const rootEpic = combineEpics(
  authEpic,
  updateUserInfoEpic,
  verificationEpic
);

export type Store = ReturnType<typeof rootReducer>;
